import { Button } from '@cluey/cluey-components/dist/components/atoms/Button/Button';
import { Container } from '@cluey/cluey-components/dist/components/atoms/Container/Container';
import classNames from 'classnames';
import { useContext } from 'react';
import { useHistory } from 'react-router';

import { CheckIcon } from '../../../../icons';
import { PATH_HUB_ENROLMENT_DETAIL } from '../../../../util/pagePath';
import { TRACKING_PE } from '../../../../util/trackingClasses';
import { PauseEnrolmentContext } from '../../pause-enrolment/PauseEnrolmentContext';

const CancelEnrolmentSuccess = () => {
  const history = useHistory();
  const { selectedEnrolment } = useContext(PauseEnrolmentContext);
  const { student, subject } = selectedEnrolment;

  return (
    <Container className="flex flex-col items-center gap-9 px-4 py-7 md:py-8 lg:mb-0">
      <div
        className={classNames('mt-10 flex flex-col items-center gap-2', {
          [TRACKING_PE.SUCCESS]: TRACKING_PE.SUCCESS,
        })}
      >
        <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-green-4">
          <CheckIcon className="text-white" width={40} height={40} />
        </div>
        <h1 className="text-center font-display text-[32px] font-bold sm:text-[40px]">Cancellation request received</h1>
      </div>
      <div className="flex flex-col items-center gap-4 text-lg">
        <p>
          We have received your request to cancel your enrolment. You will receive a confirmation email with details
          shortly.
        </p>
      </div>
      <Button
        onClick={() => {
          history.push(`${PATH_HUB_ENROLMENT_DETAIL}?token=${selectedEnrolment.enrolmentId}`);
        }}
        size="lg"
        appearance="reverse"
      >
        View {student}&apos;s {subject} enrolment
      </Button>
      <div className="h-[150px]" />
    </Container>
  );
};

export default CancelEnrolmentSuccess;
